export default "__VITE_ASSET__abcba570__"